import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import Grid from '@mui/material/Grid'
import { css } from '@emotion/css'
import { Button, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material'

import { ETranslationNs, IVerificationCodeForm } from 'src/types'

import { useStyles } from '../sign-up/styles'
import { HelperWrapper } from '../helper-wrapper'
import { handleTrimValueOnPaste } from 'src/common/handlers'
import { TextInputWithHelper } from '../text-input-with-helper-icon'

const VerificationForm = () => {
  const [t] = useTranslation()
  const { errors, values, handleChange, isSubmitting, setFieldValue } =
    useFormikContext<IVerificationCodeForm>()
  const theme = useTheme()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile_s'))
  const classes = useStyles()

  return (
    <Grid
      container
      display="flex"
      direction="column"
      justifyContent="center"
      alignItems="center"
      className={css(
        // `height: ${isTablet ? '90vh' : '100%'};`,
        isLaptop && `width: 500px; margin: auto;`,
        isTablet && `width: 100%;`,
        isMobile && `width: 100vw;`,
      )}
    >
      <Grid item xs={12} mb={2} className={classes.containerField}>
        <TextInputWithHelper
          fullWidth
          withoutPlaceholderPrepend
          inputName="code"
          handleChange={handleChange}
          value={values.code}
          error={errors.code ? t(errors.code + '.v') : ''}
          inputPlaceholder={t('signup-email-verify-code-input-placeholder.v')}
          inputUpperLabel={
            <HelperWrapper
              t={'signup-email-verify-code-input-label'}
              ns={ETranslationNs.Common}
              isInputLable
              isMandatory
            />
          }
          handlePaste={(event) => handleTrimValueOnPaste(event, values.code, setFieldValue, 'code')}
        />
      </Grid>
      {/* <Grid item display="flex" flexDirection={'column'}> */}
      <Button
        type="submit"
        variant="contained"
        disabled={isSubmitting || Object.values(errors).length > 0}
        color="secondary"
        sx={{ width: '100%', color: '#fff', height: '46px', mb: 2 }}
      >
        {t('signup-email-verify-submit-button.v')}
      </Button>
      {/* </Grid> */}
    </Grid>
  )
}

export { VerificationForm }
